module.exports = __webpack_public_path__ + "img/01.ff9b4bee.webp";